// removed by extract-text-webpack-plugin
module.exports = {"shape":"src-components-commons-Shape-style----general-module---shape---1yCHn position-absolute overflow-hidden","losange":"src-components-commons-Shape-style----general-module---losange---3Y0CT","rectangle":"src-components-commons-Shape-style----general-module---rectangle---16ZRr","square":"src-components-commons-Shape-style----general-module---square---3Twv5","center":"src-components-commons-Shape-style----general-module---center---1WqSD pinCenter"};


//////////////////
// WEBPACK FOOTER
// ./src/components/commons/Shape/style/general.module.css
// module id = 1430
// module chunks = 168707334958949